import React from "react";
import styled from "styled-components";
import BusySpinner from "./busySpinner";

export const SpinnerContainer = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

// ---------------- BUSY --------------
const BusyContainer = styled.div`
  align-items: center;
  background: white;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 5000;
`;

const BusyText = styled.h3`
  color: #222;
  font-size: 1.5rem;
  padding-bottom: 1rem;
`;

export const Busy = (props) => (
  <BusyContainer>
    <BusyText>{props.text}</BusyText>
    <BusySpinner color="#222" />
  </BusyContainer>
);
